/**
 * QrGlyph — a brand-framed QR placeholder glyph for the distribute one-pager.
 * Renders a real QR when `value` is supplied (qrcode.react is in deps), else a
 * calm branded placeholder. Brand tokens only.
 */
import { QRCodeSVG } from "qrcode.react";

interface QrGlyphProps {
  /** URL/text to encode. When omitted, shows a branded placeholder. */
  value?: string;
  size?: number;
  className?: string;
}

export const QrGlyph = ({ value, size = 132, className }: QrGlyphProps) => {
  return (
    <div
      className={`p-[2px] rounded-2xl bg-gradient-to-r from-[#4E9CFF] to-[#FF4DB8] ${className ?? ""}`}
    >
      <div
        className="rounded-[14px] bg-white flex items-center justify-center"
        style={{ width: size, height: size }}
      >
        {value ? (
          <QRCodeSVG value={value} size={Math.round(size * 0.78)} fgColor="#222B45" level="M" />
        ) : (
          <div
            className="rounded-lg bg-genie-primary/10"
            style={{ width: Math.round(size * 0.6), height: Math.round(size * 0.6) }}
          />
        )}
      </div>
    </div>
  );
};

export default QrGlyph;
